export const baseURL = "https://casino.candylivevoice.com/";
export const adminBaseURL = "https://admin.candylivevoice.com/";
export const key = "xj$6^9^b*6pvj2%s1s4e!x$zty4n!z2%v8!$zx5gn0ir8_6)";